import {createTheme} from "@mui/material/styles";


const theme=createTheme({
    typography:{
        fontFamily:'Roboto'
    },
    palette:{
        primary:{
            main:"#181818",
            light:"#202020",
            contrastText:"#FFFFF",
            dark:"#121212"
        },
        secondary:{
            main:"#4CA3FC",
            contrastText:"#FFFFFF"
        }
        
    }
})

export default theme;